import { createSelector } from 'reselect';

const selectLanguages = (state: any) => state.languages;


export const selectCurrentItem = createSelector([selectLanguages], (languages) => languages.current);

export const selectListItems = createSelector([selectLanguages], (languages) => languages.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCreatedItem = createSelector([selectLanguages], (languages) => languages.create);

export const selectUpdatedItem = createSelector([selectLanguages], (languages) => languages.update);

export const selectReadItem = createSelector([selectLanguages], (languages) => languages.read);

export const selectDeletedItem = createSelector([selectLanguages], (languages) => languages.delete);

export const selectSearchedItems = createSelector([selectLanguages], (languages) => languages.search);

export const selectItemsCount = createSelector([selectLanguages], (languages) => languages.count);

export const selectItemsFilter = createSelector([selectLanguages], (languages) => languages.filter);